<div class="container-fluid">
  <div class="row">
    <div class="card p-0">
      <div class="row m-0">
        <div class="col-sm-6 hidden-mobile left-image">
        </div>
        <div class="col-sm-6  form-div">
          <img src="../../../../../assets/Logo-new.svg" class="pt-3">
          <h6>Change Password</h6>
          <form name="form" class="p-2" (submit)="loginForm.form.valid && onResetPassword(loginForm)"
            #loginForm="ngForm" novalidate>
            <div class="form-row">
              <div class="form-group col mb-0">
                <div class="input-group  ml-auto">
                  <input [type]="fieldTextType ? 'text' : 'password'" name="password" placeholder="New Password"
                    class="form-control" [(ngModel)]="model.password" #password="ngModel"
                    [ngClass]="{ 'is-invalid': loginForm.submitted && password.invalid }" required>
                  <div *ngIf="loginForm.submitted && password.invalid" class="invalid-feedback">
                    <div *ngIf="password.errors.required">Password is required</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mt-3">
              <div class="form-group col mb-0">
                <div class="input-group  ml-auto">
                  <input  name="confirmPassword" [type]="fieldTextType1 ? 'text' : 'password'"
                    placeholder="Confirm Password" class="form-control" [(ngModel)]="model.confirmPassword"
                    #confirmPassword="ngModel"
                    [ngClass]="{ 'is-invalid': loginForm.submitted && confirmPassword.invalid }" required>
                  <span class="input-group-append" (click)="toggleFieldTextType1()">
                    <div class="input-group-text bg-transparent" style="border-top-right-radius: 50px;
                          border-bottom-right-radius: 50px;"> <i class="fa" [ngClass]="{
                                                  'fa-eye-slash': !fieldTextType1,
                                                  'fa-eye': fieldTextType1
                                                }"></i>
                    </div>
                  </span>
                  <div *ngIf="loginForm.submitted && confirmPassword.invalid" class="invalid-feedback">
                    <div *ngIf="confirmPassword.errors.required">Confirm Password is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-4 ">
              <button class="  mr-1 mb-2" type="submit">Submit</button>
            </div>




          </form>
        </div>
      </div>
    </div>
  </div>
</div>


